(ns serv-ui.theme
  "Nord (https://www.nordtheme.com/), in its dark and its light form. Which
  one is on is the machine's choice, followed live: an admin window has no
  settings page to ask on."
  (:require ["@mui/material/styles" :as mui-styles]))

(def nord
  {:nord0 "#2e3440" :nord1 "#3b4252" :nord2 "#434c5e" :nord3 "#4c566a"
   :nord4 "#d8dee9" :nord5 "#e5e9f0" :nord6 "#eceff4"
   :nord7 "#8fbcbb" :nord8 "#88c0d0" :nord9 "#81a1c1" :nord10 "#5e81ac"
   :nord11 "#bf616a" :nord12 "#d08770" :nord13 "#ebcb8b" :nord14 "#a3be8c"
   :nord15 "#b48ead"})

(def dark
  {:bg (:nord0 nord) :panel (:nord1 nord) :raised (:nord2 nord) :line (:nord3 nord)
   :fg (:nord6 nord) :dim (:nord4 nord) :accent (:nord8 nord) :second (:nord9 nord)
   :control (:nord12 nord)})

(def light
  {:bg (:nord6 nord) :panel (:nord5 nord) :raised "#ffffff" :line (:nord4 nord)
   :fg (:nord0 nord) :dim (:nord3 nord) :accent (:nord10 nord) :second (:nord9 nord)
   :control "#b4643f"})

(defn colors [mode] (if (= "dark" mode) dark light))

(def system-font "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif")

(defn mk
  "The theme for `mode`. `font` replaces the system's sans. `control` is the
  colour of what the user clicks to answer (Nord's orange), apart from
  `primary`, which is the window's own."
  ([mode] (mk mode nil))
  ([mode {:keys [font]}]
    (let [c (colors mode)]
      (mui-styles/createTheme
       (clj->js
        {:palette    {:mode       mode
                      ;; text on a coloured ground is white, always
                      :contrastThreshold 1
                      :background {:default (:bg c) :paper (:panel c)}
                      :text       {:primary (:fg c) :secondary (:dim c)}
                      :primary    {:main (:accent c)}
                      :secondary  {:main (:second c)}
                      :control    {:main (:control c) :contrastText "#fff"}
                      :error      {:main (:nord11 nord)}
                      :warning    {:main (:nord13 nord)}
                      :success    {:main (:nord14 nord)}
                      :info       {:main (:nord9 nord)}
                      :divider    (:line c)}
         :shape      {:borderRadius 6}
         :typography {:fontFamily (or font system-font)
                      :button     {:textTransform "none"}}
         :components {:MuiCssBaseline
                      {:styleOverrides
                       {"::selection"    {:backgroundColor (:accent c) :color (:bg c)}
                        ":focus-visible" {:outlineColor (:accent c)}
                        "html"           {:colorScheme mode :accentColor (:accent c)}}}
                      :MuiPaper {:styleOverrides {:root {:backgroundImage "none"}}}
                      :MuiMenu  {:styleOverrides {:paper {:backgroundColor (:raised c)}}}}})))))
